import Vue from 'vue'
import {criteriosJulgamento, mutationTypes, produto} from '@/core/constants'
import FileManagerUtils from '@/core/utils/FileManagerUtils'
import i18n from '@/i18n'

export default {

    [mutationTypes.COMPRADOR.SET_SITUACAO_REAJUSTE_DE_PROPOSTAS](state, { reajustePropostaId, reajustePropostaSituacao }) {

        let index = null
        index = state.compraDireta.analiseDocumentos.documentosNaoAnalizaveis.findIndex(doc => doc.reajusteId === reajustePropostaId)
        if (index !== -1) {
            Vue.set(state.compraDireta.analiseDocumentos.documentosNaoAnalizaveis[index], 'situacao', reajustePropostaSituacao)
        }
    },

    [mutationTypes.COMPRADOR.SET_ANALISE_DOCUMENTOS_DO_FORNECEDOR](state, resultado) {
        state.compraDireta.analiseDocumentos = Object.assign({
            documentosAnalizaveis: [],
            documentosNaoAnalizaveis: [],
            situacao: null,
            situacaoCompra: null,
            situacaoItemLote: null,
            situacaoFornecedor: null,
            ehCompraDiretaVirtualizada: false
        }, resultado || {})

        if (!Array.isArray(state.compraDireta.analiseDocumentos.documentosAnalizaveis)) {
            Vue.set(state.compraDireta.analiseDocumentos, 'documentosAnalizaveis', [])
        }
        if (!Array.isArray(state.compraDireta.analiseDocumentos.documentosNaoAnalizaveis)) {
            Vue.set(state.compraDireta.analiseDocumentos, 'documentosNaoAnalizaveis', [])
        }
    },

    [mutationTypes.COMPRADOR.SET_ATUALIZAR_ANALISE_DE_DOCUMENTO](state, resultado) {
        let index = null
        index = state.compraDireta.analiseDocumentos.documentosAnalizaveis.findIndex(doc => doc.documentoSolicitadoId === resultado.documentoSolicitadoId)
        if (index !== -1) {
            Vue.set(state.compraDireta.analiseDocumentos.documentosAnalizaveis[index], 'situacao', resultado.novaSituacao)
        }
    },

    [mutationTypes.COMPRADOR.SET_ASSINATURA_SOLICITADA_DOCUMENTO_APRESENTADO](state, data) {
        let index = null
        index = state.compraDireta.analiseDocumentos.documentosAnalizaveis.findIndex(doc => doc.id === data.documentoId)
        if (index !== -1) {
            Vue.set(state.compraDireta.analiseDocumentos.documentosAnalizaveis[index], 'solicitadoAssinatura', data.assinaturaSolicitada)
        }
    },

    [mutationTypes.COMPRADOR.SET_ASSINATURA_SOLICITADA_REAJUSTE_PROPOSTA](state, data) {
        let index = null
        index = state.compraDireta.analiseDocumentos.documentosNaoAnalizaveis.findIndex(doc => doc.origemId === data.documentoId)
        if (index !== -1) {
            Vue.set(state.compraDireta.analiseDocumentos.documentosNaoAnalizaveis[index], 'solicitadoAssinatura', data.assinaturaSolicitada)
        }
    },

    [mutationTypes.COMPRADOR.SET_AUTOCOMPLETE_IMPORTAR_COMPRA_DIRETA](state, processos) {
        Vue.set(state.comprador, 'processosAutocomplete', processos)
    },

    [mutationTypes.COMPRADOR.SET_FILTROS_BUSCA_COMPRA_DIRETA_EM_ANDAMENTO](state, filtros) {
        state.comprador.resultadoBuscaComprasDiretasEmAndamento.filtros = filtros
    },

    [mutationTypes.COMPRADOR.SET_FILTROS_BUSCA_COMPRA_DIRETA_EM_ELABORACAO](state, filtros) {
        state.comprador.resultadoBuscaComprasDiretasEmElaboracao.filtros = filtros
    },

    [mutationTypes.COMPRADOR.SET_FILTROS_BUSCA_COMPRA_DIRETA_ENCERRADA](state, filtros) {
        state.comprador.resultadoBuscaComprasDiretasEncerradas.filtros = filtros
    },

    [mutationTypes.COMPRADOR.SET_FILTROS_BUSCA_TODAS_COMPRAS_DIRETAS](state, filtros) {
        state.comprador.resultadoBuscaTodasComprasDiretas.filtros = filtros
    },

    [mutationTypes.COMPRADOR.SET_FILTROS_BUSCA_AVANCADA_COMPRAS_DIRETAS_COMPRADOR](state, filtros) {
        state.comprador.resultadoBuscaAvancadaComprasDiretas.filtros = filtros
    },

    [mutationTypes.COMPRADOR.SET_PAGINACAO_BUSCA_COMPRA_DIRETA_EM_ANDAMENTO](state, paginacao) {
        state.comprador.resultadoBuscaComprasDiretasEmAndamento.paginacao = paginacao
    },

    [mutationTypes.COMPRADOR.SET_PAGINACAO_BUSCA_COMPRA_DIRETA_EM_ELABORACAO](state, paginacao) {
        state.comprador.resultadoBuscaComprasDiretasEmElaboracao.paginacao = paginacao
    },

    [mutationTypes.COMPRADOR.SET_PAGINACAO_BUSCA_COMPRA_DIRETA_ENCERRADA](state, paginacao) {
        state.comprador.resultadoBuscaComprasDiretasEncerradas.paginacao = paginacao
    },

    [mutationTypes.COMPRADOR.SET_PAGINACAO_BUSCA_TODAS_COMPRAS_DIRETAS](state, paginacao) {
        state.comprador.resultadoBuscaTodasComprasDiretas.paginacao = paginacao
    },

    [mutationTypes.COMPRADOR.SET_PAGINACAO_BUSCA_AVANCADA_COMPRAS_DIRETAS_COMPRADOR](state, paginacao) {
        state.comprador.resultadoBuscaAvancadaComprasDiretas.paginacao = paginacao
    },

    [mutationTypes.COMPRADOR.SET_RESULTADO_ATUALIZAR_DADOS_DA_COMPRA_DIRETA](state, resultado) {
        Vue.set(state.comprador.resultadoCompraDireta, 'casasDecimais', resultado.casaDecimal)
        Vue.set(state.comprador.resultadoCompraDireta, 'disputaPor', resultado.disputaPor)
        Vue.set(state.comprador.resultadoCompraDireta, 'tipo', resultado.tipoCompraDireta)
        Vue.set(state.comprador.resultadoCompraDireta, 'numeroProtocolo', resultado.numeroProtocoloEsfinge)
        Vue.set(state.comprador.resultadoCompraDireta, 'numeroProtocoloOcorrencia', resultado.numeroProtocoloOcorrenciaEsfinge)
        Vue.set(state.comprador.resultadoCompraDireta, 'existeItemLoteComSituacaoEmAndamento', resultado.existeItemLoteComSituacaoEmAndamento)
    },

    [mutationTypes.COMPRADOR.SET_RESULTADO_ITENS_E_LOTES](state, resultado) {
        state.comprador.resultadoItensELotes = resultado
    },

    [mutationTypes.COMPRADOR.SET_SITUACAO_NEGOCIACAO](state, resultado) {
        let index = null
        index = state.comprador.resultadoItensELotes.findIndex(itemOuLote => itemOuLote.id === resultado.itemOuLoteId)
        if (index !== -1) {
            let rankingIndex = null
            rankingIndex = state.comprador.resultadoItensELotes[index].ranking.findIndex(ranking => ranking.rankingId === resultado.rankingId)
            if (rankingIndex !== -1) {
                Vue.set(state.comprador.resultadoItensELotes[index].ranking[rankingIndex], 'negociacao', {
                    id: resultado.id,
                    aceito: null,
                    mensagem: resultado.mensagemComprador,
                    valor: resultado.valorPosterior
                })
            }
        }
    },

    [mutationTypes.COMPRADOR.SET_SITUACAO_RANKING_EM_ANALISE](state, dados) {
        let index = null
        index = state.comprador.resultadoItensELotes.findIndex(itemOuLote => itemOuLote.id === dados.itemOuLoteId)
        if (index !== -1) {
            let rankingIndex = null
            rankingIndex = state.comprador.resultadoItensELotes[index].ranking.findIndex(ranking => ranking.rankingId === dados.rankingId)
            if (rankingIndex !== -1) {
                Vue.set(state.comprador.resultadoItensELotes[index].ranking[rankingIndex], 'status', 'EM_ANALISE')
            }
        }
    },

    [mutationTypes.COMPRADOR.SET_FILTROS_BUSCA_REQUISICOES_POR_SISTEMA](state, filtros) {
        state.comprador.filaRequisicoes.filtros = filtros
    },


    [mutationTypes.COMPRADOR.SET_PAGINACAO_BUSCA_REQUISICOES_POR_SISTEMA](state, paginacao) {
        state.comprador.filaRequisicoes.paginacao = paginacao
    },

    [mutationTypes.COMPRADOR.SET_FILTROS_BUSCA_COMPRAS_LEGADAS](state, filtros) {
        state.comprador.resultadoBuscaComprasLegadas.filtros = filtros
    },

    [mutationTypes.FORNECEDOR.SET_ATUALIZAR_DOCUMENTO_SOLICITADO_DA_PROPOSTA](state, resultado) {
        let index = null
        index = state.fornecedor.documentosSolicitados.findIndex(doc => doc.documentoSolicitadoId === resultado.documentoSolicitadoId)
        if (index !== -1) {
            Vue.set(state.fornecedor.documentosSolicitados[index], 'id', resultado.id)
            Vue.set(state.fornecedor.documentosSolicitados[index], 'uri', resultado.uri)
            Vue.set(state.fornecedor.documentosSolicitados[index], 'situacao', resultado.situacao)
        }
    },

    [mutationTypes.FORNECEDOR.SET_ATUALIZAR_TODOS_DOCUMENTOS_SOLICITADOS_DA_PROPOSTA](state, resultado) {
        Vue.set(state.fornecedor.documentosSolicitados, resultado.documentos)
    },

    [mutationTypes.FORNECEDOR.SET_ATUALIZAR_MEU_ULTIMO_LANCE](state, resultado) {
        let index = null
        if (resultado.dados.tipo === 'ITEM') {
            index = state.lancesDaCompraDireta.findIndex(lance => lance.itemCompraDiretaId === resultado.dados.itemCompraDiretaId)
            if (index !== -1) {
                Vue.set(state.lancesDaCompraDireta[index], 'id', resultado.data.id)
                Vue.set(state.lancesDaCompraDireta[index], 'valor', resultado.dados.valor)
                Vue.set(state.lancesDaCompraDireta[index], 'melhorLance', resultado.data.melhorLance)
                Vue.set(state.lancesDaCompraDireta[index], 'ganhando', resultado.data.ganhando)
                Vue.set(state.lancesDaCompraDireta[index], 'valorInserido', null)
                Vue.set(state.lancesDaCompraDireta[index], 'podeCancelar', resultado.dados.podeCancelar)
            }
        } else {
            index = state.lancesDaCompraDireta.findIndex(lance => lance.loteCompraDiretaId === resultado.dados.loteCompraDiretaId)
            if (index !== -1) {
                Vue.set(state.lancesDaCompraDireta[index], 'valor', resultado.dados.valor)
                Vue.set(state.lancesDaCompraDireta[index], 'id', resultado.data.id)
                Vue.set(state.lancesDaCompraDireta[index], 'melhorLance', resultado.data.melhorLance)
                Vue.set(state.lancesDaCompraDireta[index], 'ganhando', resultado.data.ganhando)
                Vue.set(state.lancesDaCompraDireta[index], 'podeCancelar', resultado.dados.podeCancelar)
                Vue.set(state.lancesDaCompraDireta[index], 'valorInserido', null)
            }
        }
    },

    [mutationTypes.FORNECEDOR.SET_ATUALIZAR_ITEM_E_LOTE_DA_PROPOSTA](state, resultado) {
        let indexItem = null
        let indexLote = null
        let indexLoteItem = null
        if (resultado.loteId) {
            indexLote = state.itensELotesDaProposta.lotes.findIndex(lote => lote.loteId === resultado.loteId)
            if (indexLote !== -1) {
                indexLoteItem = state.itensELotesDaProposta.lotes[indexLote].itens.findIndex(item => item.itemId === resultado.itemId)
                if (indexLoteItem !== -1) {
                    resultado.valor = resultado.valorUnitario * resultado.quantidade
                    state.itensELotesDaProposta.lotes[indexLote].itens[indexLoteItem] = resultado
                }
                let totalLote = 0
                let totalUnitarioLote = 0
                if (state.compraDireta.criterioJulgamento === criteriosJulgamento.MAIOR_DESCONTO.valor) {
                    state.itensELotesDaProposta.lotes[indexLote].itens.forEach(item => {
                        totalLote += item.valorUnitario
                    })
                    totalLote = totalLote / state.itensELotesDaProposta.lotes[indexLote].itens.length
                } else {
                    state.itensELotesDaProposta.lotes[indexLote].itens.forEach(item => {
                        item.total = item.valorUnitario * item.quantidade
                        totalLote += item.total
                        totalUnitarioLote += item.valorUnitario
                    })
                }
                Vue.set(state.itensELotesDaProposta.lotes[indexLote], 'totalGeral', totalLote)
                Vue.set(state.itensELotesDaProposta.lotes[indexLote], 'totalUnitario', totalUnitarioLote)
            }
        } else {
            indexItem = state.itensELotesDaProposta.itens.findIndex(item => item.itemId === resultado.itemId)
            if (indexItem !== -1) {
                resultado.total = resultado.valorUnitario * resultado.quantidade
                state.itensELotesDaProposta.itens[indexItem] = resultado
            }
        }
    },

    [mutationTypes.FORNECEDOR.SET_ATUALIZAR_ITEM_E_LOTE_DO_REAJUSTE](state, resultado) {
        let indexItem = null
        let indexLote = null
        let indexLoteItem = null
        if (resultado.reajusteLotePropostaId) {
            indexLote = state.fornecedor.meusItensELotesVencedoresAReajustar.reajusteLotes.findIndex(lote => lote.id === resultado.reajusteLotePropostaId)
            if (indexLote !== -1) {
                indexLoteItem = state.fornecedor.meusItensELotesVencedoresAReajustar.reajusteLotes[indexLote].reajusteItens.findIndex(item => item.id === resultado.id)
                if (indexLoteItem !== -1) {
                    Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar.reajusteLotes[indexLote].reajusteItens[indexLoteItem], 'id', resultado.id)
                    Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar.reajusteLotes[indexLote].reajusteItens[indexLoteItem], 'valorUnitarioReajustado',
                        resultado.valorUnitarioReajustado)
                    Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar.reajusteLotes[indexLote].reajusteItens[indexLoteItem], 'valorTotal', resultado.valorTotal)
                    Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar.reajusteLotes[indexLote], 'valorTotalGeral', resultado.totalGeralLote)
                    Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar, 'valorFinalProposta', resultado.valorFinalProposta)
                }
            }
        } else {
            indexItem = state.fornecedor.meusItensELotesVencedoresAReajustar.reajusteItens.findIndex(item => item.id === resultado.id)
            if (indexItem !== -1) {
                Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar.reajusteItens[indexItem], 'id', resultado.id)
                Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar.reajusteItens[indexItem], 'valorUnitarioReajustado', resultado.valorUnitarioReajustado)
                Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar.reajusteItens[indexItem], 'valorTotal', resultado.valorTotal)
                Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar, 'valorFinalProposta', resultado.valorFinalProposta)
            }
        }
    },

    [mutationTypes.FORNECEDOR.SET_DOCUMENTOS_SOLICITADOS_DA_PROPOSTA](state, documentos) {
        Vue.set(state.fornecedor, 'documentosSolicitados', documentos)
    },

    [mutationTypes.FORNECEDOR.SET_ITENS_E_LOTES_DA_PROPOSTA](state, resultado) {
        Vue.set(state, 'itensELotesDaProposta', resultado)
    },

    [mutationTypes.FORNECEDOR.SET_LANCES_DA_COMPRA_DIRETA](state, lances) {
        Vue.set(state, 'lancesDaCompraDireta', lances)
    },

    [mutationTypes.FORNECEDOR.SET_ITENS_E_LOTES_VENCEDORES_A_REAJUSTAR](state, resultado) {
        Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar, 'valorFinalProposta', resultado.valorFinalProposta)
        Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar, 'reajusteItens', resultado.reajusteItens)
        Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar, 'reajusteLotes', resultado.reajusteLotes)
        Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar, 'reajustePropostaId', resultado.reajustePropostaId)
        Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar, 'situacaoReajuste', resultado.situacaoReajuste)
        Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar, 'idVirtualizado', resultado.idVirtualizado)
        Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar, 'reajusteAssinado', resultado.reajusteAssinado)
        Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar, 'urlVirtualizacaoReajuste', resultado.urlVirtualizacaoReajuste)
        Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar, 'solicitadoAssinatura', resultado.solicitadoAssinatura)
        Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar, 'relatorioReajuste', resultado.relatorioReajuste)
    },

    [mutationTypes.FORNECEDOR.SET_NOVO_ESTADO_DE_ACEITE_NEGOCIACAO_REAJUSTE](state, resultado) {
        let index
        if (resultado.tipo === 'ITEM') {
            index = state.fornecedor.meusItensELotesVencedoresAReajustar.reajusteItens.findIndex(reajusteItem => reajusteItem.id === resultado.elementoReajusteId)
            if(index !== -1) {
                Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar.reajusteItens[index], 'id', resultado.elementoReajusteId)
                Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar.reajusteItens[index].negociacao, 'aceito', resultado.aceito)
                if (resultado.aceito) {
                    Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar.reajusteItens[index], 'valorNegociado', resultado.valorAceito)
                }
            }
        } else {
            index = state.fornecedor.meusItensELotesVencedoresAReajustar.reajusteLotes.findIndex(reajusteLote => reajusteLote.id === resultado.elementoReajusteId)
            if(index !== -1) {
                Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar.reajusteLotes[index], 'id', resultado.elementoReajusteId)
                Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar.reajusteLotes[index].negociacao, 'aceito', resultado.aceito)
                if (resultado.aceito) {
                    Vue.set(state.fornecedor.meusItensELotesVencedoresAReajustar.reajusteLotes[index], 'valorNegociado', resultado.valorAceito)
                }
            }
        }
    },

    [mutationTypes.FORNECEDOR.SET_NOVO_VALOR_INSERIDO_PARA_LANCE](state, item) {
        let index = null
        index = state.lancesDaCompraDireta.findIndex(lance => lance.id === item.id)
        if (index !== -1) {
            Vue.set(state.lancesDaCompraDireta[index], 'valorInserido', item.valorInserido)
        }
    },

    [mutationTypes.FORNECEDOR.SET_FILTROS_BUSCA_COMPRA_DIRETA_ENCERRADA](state, filtros) {
        state.fornecedor.resultadoBuscaComprasDiretasEncerradas.filtros = filtros
    },

    [mutationTypes.FORNECEDOR.SET_PAGINACAO_BUSCA_COMPRA_DIRETA_ENCERRADA](state, paginacao) {
        state.fornecedor.resultadoBuscaComprasDiretasEncerradas.paginacao = paginacao
    },

    [mutationTypes.FORNECEDOR.SET_FILTROS_BUSCA_MINHAS_COMPRAS_DIRETAS](state, filtros) {
        state.fornecedor.resultadoBuscaMinhasComprasDiretas.filtros = filtros
    },

    [mutationTypes.FORNECEDOR.SET_FILTROS_BUSCA_MEU_INTERESSE_COMPRAS_DIRETAS](state, filtros) {
        state.fornecedor.resultadoBuscaMeuInteresseComprasDiretas.filtros = filtros
    },

    [mutationTypes.FORNECEDOR.SET_FILTROS_BUSCA_AVANCADA_COMPRAS_DIRETAS_FORNECEDOR](state, filtros) {
        state.fornecedor.resultadoBuscaAvancadaComprasDiretasFornecedor.filtros = filtros
    },

    [mutationTypes.FORNECEDOR.SET_MEUS_LOTES_E_ITENS_VENCEDORES](state, itens) {
        Vue.set(state.fornecedor, 'meusLotesEItensVencedores', itens)
    },

    [mutationTypes.FORNECEDOR.SET_PAGINACAO_BUSCA_MINHAS_COMPRAS_DIRETAS](state, paginacao) {
        state.fornecedor.resultadoBuscaMinhasComprasDiretas.paginacao = paginacao
    },

    [mutationTypes.FORNECEDOR.SET_PAGINACAO_BUSCA_MEU_INTERESSE_COMPRAS_DIRETAS](state, paginacao) {
        state.fornecedor.resultadoBuscaMeuInteresseComprasDiretas.paginacao = paginacao
    },

    [mutationTypes.FORNECEDOR.SET_PAGINACAO_BUSCA_AVANCADA_COMPRAS_DIRETAS_FORNECEDOR](state, paginacao) {
        state.fornecedor.resultadoBuscaAvancadaComprasDiretasFornecedor.paginacao = paginacao
    },

    [mutationTypes.FORNECEDOR.SET_FILTROS_BUSCA_COMPRAS_DIRETAS_DISPONIVEIS](state, filtros) {
        state.fornecedor.resultadoBuscaComprasDiretasDisponiveis.filtros = filtros
    },

    [mutationTypes.FORNECEDOR.SET_PAGINACAO_BUSCA_COMPRAS_DIRETAS_DISPONIVEIS](state, paginacao) {
        state.fornecedor.resultadoBuscaComprasDiretasDisponiveis.paginacao = paginacao
    },

    [mutationTypes.FORNECEDOR.SET_QUANTIDADE_DE_CASAS_DECIMAIS_DA_COMPRA_DIRETA](state, casasDecimais) {
        Vue.set(state.fornecedor, 'quantidadeCasasDecimaisCompraDireta', casasDecimais)
    },

    [mutationTypes.FORNECEDOR.SET_RESULTADO_DE_TODOS_LOTES_E_ITENS](state, itens) {
        Vue.set(state.fornecedor, 'resultadoTodosLotesEItens', itens)
    },

    [mutationTypes.FORNECEDOR.SET_RESUMO_DA_COMPRA_DIRETA_NA_PROPOSTA](state, resumoProposta) {
        state.resumoProposta = resumoProposta
    },

    [mutationTypes.FORNECEDOR.SET_TERMOS](state, termos) {
        Vue.set(state, 'termos', termos)
    },

    [mutationTypes.FORNECEDOR.SET_VERIFICAR_SE_POSSUI_LOTE_ITEM_VENCEDOR](state, possuiLoteItemVencedor) {
        Vue.set(state.fornecedor, 'possuiLoteItemVencedor', possuiLoteItemVencedor)
    },

    [mutationTypes.SET_ADICIONAR_ANEXO_DADOS_GERAIS](state, anexo) {
        state.dadosGerais.anexos.unshift(anexo)
    },

    [mutationTypes.SET_ADICIONAR_DOCUMENTO_SOLICITADO](state, documento) {
        state.compraDireta.documentosSolicitados.push(documento)
    },

    [mutationTypes.SET_ADICIONAR_EMAIL_CONVIDADO](state, email) {
        state.compraDireta.convidados.push(email)
    },

    [mutationTypes.SET_ADICIONAR_LINHA_DE_FORNECIMENTO](state, linha) {
        state.compraDireta.linhasFornecimento.push(linha)
        state.compraDireta.linhasFornecimento.sort((a, b) => {
            return a.linhaFornecimentoCodigo > b.linhaFornecimentoCodigo
        })
    },

    [mutationTypes.SET_ALTERAR_EXCLUSIVIDADE_ITEM](state, {id, novoValor}) {
        let index = null
        index = state.itensELotes.itens.findIndex(item => item.id === id)
        if (index !== -1)
            Vue.set(state.itensELotes.itens[index], 'porteExclusivo', novoValor)
    },

    [mutationTypes.SET_ALTERAR_EXCLUSIVIDADE_LOTE](state, {id, novoValor}) {
        let index = null
        index = state.itensELotes.lotes.findIndex(lote => lote.id === id)
        if (index !== -1)
            Vue.set(state.itensELotes.lotes[index], 'porteExclusivo', novoValor)
    },

    [mutationTypes.SET_COMPRA_DIRETA](state, compraDireta) {
        Vue.set(state, 'compraDireta', compraDireta)
    },

    [mutationTypes.COMPRADOR.SET_DADOS_ACOMPANHAMENTO](state, dados) {
        if (!state.compraDireta) {
            Vue.set(state, 'compraDireta', {})
        }
        Vue.set(state.compraDireta, 'acompanhamento', dados)
    },

    [mutationTypes.SET_HABILITAR_SALVAMENTO_AUTOMATICO](state) {
        Vue.set(state.salvamentoAutomatico, 'salvando', true)
        Vue.set(state.salvamentoAutomatico, 'dataUltimoSalvamento', null)
    },

    [mutationTypes.SET_DESABILITAR_SALVAMENTO_AUTOMATICO](state) {
        setTimeout(() => {
            Vue.set(state.salvamentoAutomatico, 'salvando', false)
            Vue.set(state.salvamentoAutomatico, 'dataUltimoSalvamento', new Date())
        }, 500)
    },

    [mutationTypes.SET_DADOS_GERAIS](state, dadosGerais) {
        Vue.set(state, 'dadosGerais', dadosGerais)
    },

    [mutationTypes.SET_DOCUMENTOS](state, documentos) {
        Vue.set(state, 'documentos', documentos)
    },

    [mutationTypes.SET_DOCUMENTOS_PROPOSTA](state, documentos) {
        Vue.set(state, 'documentosProposta', documentos)
    },

    [mutationTypes.SET_DOCUMENTOS_SOLICITADOS](state, documentos) {
        state.compraDireta.documentosSolicitados = documentos
    },

    [mutationTypes.SET_CONVIDADOS_DA_COMPRA_DIRETA](state, emails) {
        state.compraDireta.convidados = emails
    },

    [mutationTypes.SET_EXPANDIR_MENU](state) {
        Vue.set(state.loki, 'asideClosed', false)
    },

    [mutationTypes.SET_ITENS_E_LOTES](state, itensELotes) {
        state.itensELotes = itensELotes
    },

    [mutationTypes.SET_LINHAS_DE_FORNECIMENTO](state, linhas) {
        Vue.set(state, 'linhasFornecimento', linhas)
    },

    [mutationTypes.SET_LINHAS_DE_FORNECIMENTO_DA_COMPRA_DIRETA](state, linhas) {
        state.compraDireta.linhasFornecimento = linhas
    },

    [mutationTypes.SET_LINK_ARQUIVO](state) {
        Vue.set(state.loki.file, 'api', '/compra-direta/api/v1/arquivos')
    },

    [mutationTypes.SET_MENU_AVATAR](state) {
        const labelNome = i18n.t('main.store_mutations_menu_trocar_dominio.text')
        const perfilTrocaDominio = state.loki.user.type === 'EXTERNO' ? 'Empresa' : labelNome
        const titleMenuTrocaDominio = `Trocar de ${perfilTrocaDominio}`
        let actions = {}
        const integrationDashboard = {title: 'Situação Integrações', icon: 'power', path: '/informacoes-sistema'}
        if (state.perfis.length > 1) {
            actions = {
                1: {title: titleMenuTrocaDominio, icon: 'repeat', path: '/selecionar-dominio'},
                2: {title: 'Perfil', icon: 'person', path: '/perfil'},
            }
        } else {
            actions = {
                1: {title: 'Perfil', icon: 'person', path: '/perfil'},
            }
        }

        // console.dir(state.loki.user)
        //.authorities, ['Comprador.Normal', 'Comprador.Admin']

        //TODO isso tem que ser baseado no novo perfil de usuário "suporte"
        if(state.loki.user.type === 'INTERNO' && state.parametros.propriedadesCompraDiretas.modoCriacao !== 'MANUAL'){
            if (2 in actions){
                actions[3] = integrationDashboard
            }else{
                actions[2] = integrationDashboard
            }
        }

        Vue.set(state.loki, 'avatarActions', actions)
    },

    [mutationTypes.SET_PARAMETROS](state, parametros) {
        state.parametros = parametros
    },

    [mutationTypes.SET_PERFIS](state, perfis) {
        state.perfis = perfis.filter(function (perfil) {return perfil.produtoId === 300})
    },

    [mutationTypes.SET_PRODUTO](state, data) {
        state.loki.product.id = data.id
        state.loki.product.name = data.nome
        state.loki.product.mainLogo = FileManagerUtils.createUrl(data.atributosExtendidos.logoMenu)
        state.loki.product.symbolLogo = FileManagerUtils.createUrl(data.atributosExtendidos.logoMenuRetraido)
        state.loki.product.logoMobile = FileManagerUtils.createUrl(data.atributosExtendidos.logoMobile)
        state.loki.product.version = produto.VERSAO
        state.loki.product.copywrite = produto.COPYRIGHT
        state.loki.product.logoutUrl = produto.LOGOUT_URL
    },

    [mutationTypes.SET_REMOVER_ANEXO_DADOS_GERAIS](state, anexoId) {
        const index = state.dadosGerais.anexos.findIndex(anx => anx.id === anexoId)
        state.dadosGerais.anexos.splice(index, 1)
    },

    [mutationTypes.SET_SITUACAO_ANEXO](state, {anexoId, situacao}) {
        const index = state.dadosGerais.anexos.findIndex(anx => anx.id === anexoId)
        if (index !== -1) {
            Vue.set(state.dadosGerais.anexos[index], 'situacao', situacao)
        }
    },

    [mutationTypes.SET_REMOVER_DOCUMENTO_SOLICITADO](state, documentoSolicitadoId) {
        const index = state.compraDireta.documentosSolicitados.findIndex(doc => doc.id === documentoSolicitadoId)
        state.compraDireta.documentosSolicitados.splice(index, 1)
    },

    [mutationTypes.SET_REMOVER_EMAIL_CONVIDADO](state, convidadoId) {
        const index = state.compraDireta.convidados.findIndex(doc => doc.id === convidadoId)
        state.compraDireta.convidados.splice(index, 1)
    },

    [mutationTypes.SET_REMOVER_ITEM](state, itemId) {
        let index = null
        index = state.itensELotes.itens.findIndex(item => item.id === itemId)
        if (index !== -1) {
            state.itensELotes.itens.splice(index, 1)
        }
    },

    [mutationTypes.SET_REMOVER_LINHA_FORNECIMENTO](state, linhaId) {
        const index = state.compraDireta.linhasFornecimento.findIndex(doc => doc.id === linhaId)
        state.compraDireta.linhasFornecimento.splice(index, 1)
    },

    [mutationTypes.SET_REMOVER_LOTE](state, loteId) {
        let index = null
        index = state.itensELotes.lotes.findIndex(lote => lote.id === loteId)
        if (index !== -1) {
            state.itensELotes.lotes.splice(index, 1)
        }
    },

    [mutationTypes.SET_RESUMO_DA_COMPRA_DIRETA](state, resumo) {
        state.resumoCompraDireta = resumo
    },

    [mutationTypes.SET_RESUMO_ITEM_E_LOTE](state, resumoItemELote) {
        state.resumoItemELote = resumoItemELote
    },

    [mutationTypes.SET_RETRAIR_MENU](state) {
        Vue.set(state.loki, 'asideClosed', true)
    },

    [mutationTypes.SET_LOADING_LOCAL_EXIBIR](state, exibir) {
        state.loadingLocal.exibir = exibir
    },

    [mutationTypes.SET_LOADING_LOCAL_MENSAGEM](state, mensagem) {
        state.loadingLocal.mensagem = mensagem
    },

    [mutationTypes.SET_ROTA_ORIGEM](state, rota) {
        state.rota.origem = rota
    },
    [mutationTypes.SET_ROTA_VOLTA](state, rota) {
        state.rotaVolta = rota
    },
    [mutationTypes.SET_EXECUCAO_ATIVA](state, execucao) {
        state.execucaoAtiva = execucao
    },

    [mutationTypes.SET_USUARIO_LOGADO](state, usuario) {
        const user = {
            id: usuario.userId,
            name: usuario.userName,
            fullName: usuario.name,
            photo: FileManagerUtils.createThumbnailUrl(usuario.imageUrl),
            type: usuario.tipoUsuario,
            domainId: usuario.domainId,
            domainName: usuario.domainName,
            domainType: usuario.domainType,
            authorities: usuario.authorities
        }
        Vue.set(state.loki, 'user', user)
    },

    [mutationTypes.SET_ORGAOS_DISPONIVEIS](state, orgaos) {
        Vue.set(state.dadosGerais, 'orgaos', orgaos)
    },

    [mutationTypes.SET_LINGUAGEM](state, linguagem) {
        state.linguagem = linguagem
    },

    [mutationTypes.LOKI.SET_NOTIFICACOES](state, { notificacoes, totalPages}){
        const page = state.notificacoes.paginacao.page
        const messages = notificacoes.map(notif => {
            const { titulo, introTitulo, mensagem, dataCadastro, situacao, uriRedirect, ...dados } = notif
            const outrasClasses = (situacao === 'NAO_VISUALIZADA') ? 'font-weight-bold':'text-ligten-2'
            return {
                text: `<span class="primary--text text-uppercase ${outrasClasses}"  style="font-size: 14px"> ${introTitulo} </span> <br/> 
                        <span class="primary--text ${outrasClasses}"> ${titulo} </span>
                         <br/> ${mensagem !== null ? mensagem : ''} <br/>
                        <a href="/compra-direta/#${uriRedirect}">Acesse</a>`,
                when: dataCadastro,
                read: (situacao === 'VISUALIZADA'),
                ...dados
            }
        })

        state.notificacoes.mensagens.push(...messages)
        Vue.set(state.loki.notification, 'messages', state.notificacoes.mensagens)
        Vue.set(state.loki.notification, 'viewMore', totalPages > page)
    },

    [mutationTypes.LOKI.SET_NOTIFICACOES_NAO_LIDAS](state, totalNaoLidas){
        Vue.set(state.loki.notification, 'unread', totalNaoLidas)
    },

    [mutationTypes.SET_NOTIFICACOES_PAGE](state, page){
        if(page) {
            state.notificacoes.paginacao.page = page
            state.notificacoes.mensagens = []
        }
        else
            state.notificacoes.paginacao.page += 1
    },

    [mutationTypes.NOTIFICACOES_RESET_FILTROS](state){
        state.notificacoes.filtros.situacoes = state.notificacoes.situacoesIniciais
    },

    [mutationTypes.SET_DEVE_ABRIR_CHAT](state, value){
        state.chat.deveAbrirChat = value
        if(!value) {
            state.chat.conversacao.mensagens = []
        }
    },

    [mutationTypes.SET_CHAT_CONVERSACAO_MENSAGENS](state, mensagens){
        if(!mensagens || mensagens.length <= 0) state.chat.conversacao.mensagens = []
        else
            state.chat.conversacao.mensagens.push(...mensagens)
    },

    [mutationTypes.SET_CHAT_CONVERSACAO_DESTINATARIO](state, destinatario){
        state.chat.conversacao.destinatario = destinatario
    },

    [mutationTypes.SET_CHAT_DESTINATARIO_ONLINE](state, payload){
        const atual = state.chat.conversacao.destinatario || {}
        if (!payload || !payload.id) return
        if (Number(atual.id) !== Number(payload.id)) return
        state.chat.conversacao.destinatario = {
            ...atual,
            online: Boolean(payload.online)
        }
    },

    [mutationTypes.SET_CHAT_CONVERSACAO_DETALHES_COMPRA](state, detalhes){
        state.chat.conversacao.compra = detalhes
    },

    [mutationTypes.SET_CHAT_NOTIFICACOES](state, data){
        state.chat.paginacao.totalPages = data.totalPages
        state.chat.mensagensResumidas.push(...data.mensagens)
    },

    [mutationTypes.SET_CHAT_MENSAGENS_NOTIFICACOES_PAGE](state, page){
        if(page) {
            state.chat.paginacao.page = page
            state.chat.mensagensResumidas = []
        }
        else
            state.chat.paginacao.page += 1
    },

    [mutationTypes.SET_NOTIFICAO_CHAT_PARA_LIDA](state, data){
        state.chat.mensagensResumidas.filter(mensagem => mensagem.id === data.id).map(mensagem => mensagem.lida=data.lida)
        state.chat.msgResumidasNaoLidas = state.chat.msgResumidasNaoLidas-1
    },

    [mutationTypes.SET_NOTIFICAO_PARA_LIDA](state, data){
        state.notificacoes.mensagens.filter(mensagem => mensagem.id === data.id).map(mensagem => mensagem.read=data.lida)
        Vue.set(state.loki.notification, 'messages', state.notificacoes.mensagens)
    },

    [mutationTypes.SET_CHAT_MENSAGENS_NOTIFICACOES](state, data){
        state.chat.mensagensResumidas.unshift(data.mensagens)
    },

    [mutationTypes.SET_CHAT_NOTIFICACOES_NAO_LIDAS](state, totalNaoLidas){
        state.chat.msgResumidasNaoLidas = totalNaoLidas
    },

    [mutationTypes.SET_WEBSOCKET_SERVICE](state, service){
        state.websocketService = service
    },

    [mutationTypes.SET_TOTAL_MENSAGENS_NAO_LIDAS_CENTRAL](state, totalNaoLidas){
        state.chat.centralMensagens.totalNaoLidas = totalNaoLidas
    },

    [mutationTypes.SET_USUARIOS_ONLINE_COMPRA_DIRETA](state, usuarioOnline){
        const index = state.chat.usuariosOnline.findIndex(usuario =>  {
            return  (usuario.usuarioId === usuarioOnline.usuarioId &&
                    usuario.dominioId === usuarioOnline.dominioId &&
                    usuario.tipo === usuarioOnline.tipo)

        })

        if(index >= 0)
            state.chat.usuariosOnline[index].online = usuarioOnline.online
        else
            state.chat.usuariosOnline.push(usuarioOnline)
    },

    [mutationTypes.SET_CURRENT_TAB_CHAT](state, value){
        state.chat.currentTabChat = value
    },

    [mutationTypes.SET_ITEM_OU_LOTE_ATUAL_DO_CHAT](state, itemOuLote){
        state.chat.conversacao.itemOuLoteAtualDoChat = itemOuLote
    },

    [mutationTypes.SET_CHAT_CONVERSACAO_ESTADO_INICIAL](state){
        state.chat.conversacao = state.chat.estadoConversacaoInicial
    },

    [mutationTypes.COMPRADOR.SET_DOCUMENTO_DESENTRANHAMENTO](state, documento){
        state.documentoDesentranhamento = documento
    },

    [mutationTypes.SET_COMPRA_DIRETA_SUSPENSA](state, suspensa) {
        state.compraDiretaSuspensa = suspensa
    }
}
